import React, { useEffect } from "react";
import { Icons } from "../../atoms/Icons";
import { Card } from "react-bootstrap";
import useTRAAgeHook from "./useTRAAgeHook";
import "./traagecard.scss";
import { getAge, getApplicableMinMaxTra } from "../../helpers/trautil";
import { useSelector } from "react-redux";

const TraAgeCard = (props) => {
  const { data } = useSelector((state) => state.home);
  const {
    isUpdateEnable,
    description,
    age,
    getUpdatedAgeValue,
    doj,
    isMultiplePot,
    setShowError,
    setCurrentAge,
    schemeData,
  } = props;
  const _dob = data?.timeTravel?.birthDate;
  const getTraMinMaxAge = getApplicableMinMaxTra(_dob, doj, schemeData);
  const currentAge = getAge(_dob);
  const { ageCount, incrementAge, decrementAge, showError } = useTRAAgeHook(
    age,
    getTraMinMaxAge.min,
    getTraMinMaxAge.max,
    currentAge,
  );
  useEffect(() => {
    setCurrentAge(currentAge);
  }, [currentAge]);

  useEffect(() => {
    if (showError) {
      setShowError(true);
      return;
    } else {
      getUpdatedAgeValue(ageCount);
    }
  }, [ageCount, showError]);

  useEffect(() => {
    if (showError) {
      setShowError(false);
    }
  }, [ageCount]);

  return (
    <>
      <Card className="selected-age-container age-card ms-4 me-4">
        <p className="description">
          {isUpdateEnable
            ? isMultiplePot
              ? description +
                `. Please edit your target retirement age in the box below to between ${getTraMinMaxAge.min} and ${getTraMinMaxAge.max} years`
              : `Please edit your target retirement age in the box below to between ${getTraMinMaxAge.min} and ${getTraMinMaxAge.max} years`
            : description}
        </p>
        <div className="tra-inc-dec-age">
          {isUpdateEnable && (
            <div className={showError ? "me-3 mb-3 pointers" : "me-3 mb-3"}>
              <Icons
                iconname="icons-minus"
                variant="icon-twenty-px"
                clickHandler={() => {
                  decrementAge();
                }}
              />
            </div>
          )}

          <h1 className="tra-age noselect">{ageCount}</h1>

          {isUpdateEnable && (
            <div className="ms-3 mb-3">
              <Icons
                iconname="icons-add"
                variant="icon-twenty-px"
                clickHandler={() => {
                  incrementAge();
                }}
              />
            </div>
          )}
        </div>
      </Card>
    </>
  );
};

export default TraAgeCard;
